import { Asset, Entry } from 'contentful'
import { FlexContainer, FlexItem } from '~/components/Grid'
import { ResponsiveImage } from '~/components/ResponsiveImage'
import { TypeBlogCategorySkeleton } from '~/types/contentful'

export type CategoryHeroProps = {
  data: Entry<TypeBlogCategorySkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const CategoryHero = ({ data }: CategoryHeroProps) => {
  const { name, metaDescription, color, illustration } = data.fields

  const illutrationImage = illustration as Asset<'WITHOUT_UNRESOLVABLE_LINKS', string>

  return (
    <div
      className="relative z-1 text-neutral-100 max-md:h-[505px] max-md:pt-[calc(40px_+_var(--header-height))] max-md:text-center max-xl:h-[500px] h-[650px] pt-[calc(30px_+_var(--header-height))]"
      style={{ backgroundColor: color }}
    >
      <FlexContainer justify="end">
        <FlexItem
          className="flex max-md:flex-col relative max-xl:items-center max-xl:w-auto"
          desktop={10}
          laptop={12}
        >
          <div className="flex flex-col items-center justify-center order-2 top-21 max-xl:left-[627px] max-xl:top-17 max-xl:h-88 w-88 h-[511px] left-[928px] pt-0 px-0 pb-10 gap-3 max-md:order-1 max-md:left-16 max-md:h-30 max-md:pt-13 max-md:w-63">
            {illutrationImage && (
              <div className="block top-2 w-[330px] h-[148px] ml-[40%] max-md:order-1 max-md:ml-0 max-md:w-[235px] max-md:h-[106px] max-xl:w-[353px] max-xl:h-[168px] max-xl:ml-[20%]">
                <ResponsiveImage asset={illutrationImage.fields} opts={{ width: 544 }} />
              </div>
            )}
          </div>
          <div className="max-xl:w-[49%] max-xl:gap-6 max-xl:h-[352px] max-xl:left-11 max-lg:p-10 max-xl:top-37 flex flex-col p-0 pt-19 gap-10 h-auto top-24 order-1 left-[354px] w-[446px] max-md:order-2 max-md:gap-0 max-md:h-auto max-md:w-full max-md:py-0 max-md:px-4 max-md:text-center max-md:pt-10">
            <p className="text-2xl">{name}</p>
            {metaDescription && (
              <p className="text-s text-neutral-100 pb-25 max-md:pt-4 max-md:pb-18">
                {metaDescription}
              </p>
            )}
          </div>
        </FlexItem>
      </FlexContainer>
    </div>
  )
}
